export default __webpack_public_path__ + "static/media/downloadIFilingconGreen.64e9b1fd.svg";